<div [ngClass]="_fieldClass">
	<multi-extended-filterable-select
		[id]="id"
		[disabled]="disabled"
		[maxNumberOfSelections]="maxNumberOfSelections"
		[preselectionFunction]="isParcPreselected"
		[list]="suggestableParcs"
		[labelGetter]="getParcLabel"
		[reinitCommands]="reinitSubject"
		(selectedItemsChange)="onSelectedParcsChange($event)"
		>
	</multi-extended-filterable-select>
</div>